import KeenSlider from 'keen-slider'
import 'keen-slider/keen-slider.min.css'
export class Slider {
  constructor(slidersEl) {
    this.slidersEl = slidersEl || [...document.getElementsByClassName('js-slider')]
    if (this.slidersEl.length === 0) return
    this.sliders = this.slidersEl.map((sliderEl) => {
      sliderEl.classList.add('keen-slider')
      const slides = [...sliderEl.children]
      slides.forEach((slide) => {
        slide.classList.add('keen-slider__slide')
      })

      if (slides.length <= 4) {
        this.cloneSlides(sliderEl, slides)
      }

      let animation = { duration: 20000, easing: (t) => t }

      return new KeenSlider(sliderEl, {
        slides: {
          perView: 'auto',
        },
        mode: 'free-snap',
        loop: true,
        created(s) {
          s.moveToIdx(5, true, animation)
        },
        updated(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
        animationEnded(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
        },
      })
    })
  }
  cloneSlides(sliderEl, slides) {
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true)
      sliderEl.appendChild(clone)
    })
  }
}
